export enum ButtonType {
  Button,
}
